import { useEffect, useState } from "react";

window.googletag = window.googletag || {};
window.googletag.cmd = window.googletag.cmd || [];

export const useAdblockCheck = () => {
  const [isAdblockDetected, setIsAdblockDetected] = useState<boolean>(true);

  useEffect(() => {
    if (window.googletag && window.googletag.apiReady) {
      setIsAdblockDetected(false);
    } else {
      window.googletag.cmd.push(() => setIsAdblockDetected(false));
    }
  }, []);

  return {
    isAdblockDetected,
  };
};
